'use strict';

/**
 * Common functionality and utilities that are useful in a variety of
 * situations.
 */

const ContentUtils = {
  /**
   * Creates an objects that mimics a content.
   *
   * @param {Object} args
   * @param {string} args.id
   * @param {string} args.creationTime -
   * @param {string} args.contentType
   * @param {Object} args.aspects
   **/
  createContentObject : function(args) {
    return {
      system: {
        id: args.id,
        version: '',
        modificationTime: new Date().getTime() + '',
        creationTime: args.creationTime,
        contentType: args.contentType
      },

      aspects: args.aspects
    }
  }
};

export  { ContentUtils };
